export const dashboardSummary = {
  todaySales: 7700,
  todayCollection: 5700,
  todayExpense: 33750,
  cashStatus: 12450,
  totalCredit: 15800,
  totalSupplierDebt: 28500,
  monthlyIncome: 84700,
  monthlyExpense: 53130,
  monthlyProfit: 31570,
  upcomingCollections: 3,
  upcomingPayments: 4,
};

export const incomeExpenseChart = [
  { date: '02 May', gelir: 12000, gider: 8500 },
  { date: '05 May', gelir: 8000, gider: 12000 },
  { date: '08 May', gelir: 15000, gider: 5000 },
  { date: '11 May', gelir: 6000, gider: 7000 },
  { date: '14 May', gelir: 18000, gider: 4000 },
  { date: '17 May', gelir: 9000, gider: 11000 },
  { date: '20 May', gelir: 14000, gider: 3500 },
  { date: '23 May', gelir: 7000, gider: 8000 },
  { date: '26 May', gelir: 20000, gider: 9500 },
  { date: '29 May', gelir: 11000, gider: 6000 },
  { date: '01 Haz', gelir: 7700, gider: 33750 },
];

export const expenseCategoryChart = [
  { name: 'Kira', value: 12000, color: '#B8923A' },
  { name: 'Personel', value: 18000, color: '#D4A843' },
  { name: 'Reklam', value: 2500, color: '#C9A8A0' },
  { name: 'Kargo', value: 1200, color: '#B8C4B8' },
  { name: 'Muhasebe', value: 1500, color: '#5C4A3D' },
  { name: 'Vergi', value: 3200, color: '#2D2D2D' },
  { name: 'Diğer', value: 5300, color: '#E8C97A' },
  { name: 'Elektrik', value: 850, color: '#EFD4A8' },
  { name: 'Doğalgaz', value: 420, color: '#F5E3C5' },
  { name: 'Su', value: 180, color: '#F9ECD9' },
  { name: 'Aidat', value: 350, color: '#FDF6ED' },
];

export const profitLossChart = [
  { month: 'Ocak', kazanc: 15000, zarar: -5000 },
  { month: 'Şubat', kazanc: 22000, zarar: -8000 },
  { month: 'Mart', kazanc: 18000, zarar: -6000 },
  { month: 'Nisan', kazanc: 25000, zarar: -9000 },
  { month: 'Mayıs', kazanc: 31000, zarar: -11000 },
  { month: 'Haziran', kazanc: 31570, zarar: -53130 },
];

export const creditStatusChart = [
  { name: 'Bekliyor', value: 5800, color: '#D4A843' },
  { name: 'Kısmi Ödendi', value: 9000, color: '#B8923A' },
  { name: 'Gecikti', value: 1200, color: '#C0392B' },
  { name: 'Kapandı', value: 13200, color: '#27AE60' },
];

export const upcomingCollections = [
  { customer: 'Selin Çelik', amount: 5800, dueDate: '2026-06-10', daysLeft: 9 },
  { customer: 'Fatma Kaya', amount: 2000, dueDate: '2026-06-08', daysLeft: 7 },
  { customer: 'Merve Şahin', amount: 2000, dueDate: '2026-06-11', daysLeft: 10 },
];

export const upcomingPayments = [
  { supplier: 'İpek Tekstil', amount: 5000, dueDate: '2026-06-15', daysLeft: 14 },
  { supplier: 'Deri Moda', amount: 5000, dueDate: '2026-06-10', daysLeft: 9 },
  { supplier: 'Koton Tedarik', amount: 2500, dueDate: '2026-06-05', daysLeft: 4 },
  { supplier: 'Zarif Giyim', amount: 5000, dueDate: '2026-06-01', daysLeft: 0 },
];